import { createApiService, ConfigHelper, Api, apiMixin } from 'relapp-api';
import store from '@/store/index.js';

export default {
    ...createApiService('whois', 'domain.whois'),

    /**
     * Call the get all endpoint.
     *
     * @param {string} domain
     *
     * @return {Promise}
     */
    get(domain) {
        const route = ConfigHelper.apiUrl('domain.whois.get', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.get(route)
            .then(response => {
                let storeData = null;

                if (response.data.data) {
                    storeData = response.data.data;
                }

                store.dispatch('whois/updateItems', { domain: domain, data: storeData });

                return response;
            })
            .catch(apiMixin.methods.handleError);
    },

    /**
     * Call the enable private whois endpoint.
     *
     * @param {string} domain
     *
     * @return {Promise}
     */
    enablePrivateWhois(domain) {
        const route = ConfigHelper.apiUrl('domain.whois.enable-private-whois', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.post(route);
    },

    /**
     * Call the disable private whois endpoint.
     *
     * @param {string} domain
     *
     * @return {Promise}
     */
    disablePrivateWhois(domain) {
        const route = ConfigHelper.apiUrl('domain.whois.disable-private-whois', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.post(route);
    }
};
